module.exports = __webpack_public_path__ + "img/infoTheAlim.13d5e78c.png";